import { render, staticRenderFns } from "./ClientShow.vue?vue&type=template&id=621a7b7c&scoped=true&"
import script from "./ClientShow.vue?vue&type=script&lang=js&"
export * from "./ClientShow.vue?vue&type=script&lang=js&"
import style0 from "./ClientShow.vue?vue&type=style&index=0&id=621a7b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a7b7c",
  null
  
)

export default component.exports